import { ReactNode } from 'react';
import { Surface } from '@vst/beam';

import { useScreenResolution } from '@app/hooks';

import styles from './styles.module.scss';

const CartSummaryWrapper = ({ children }: { children: ReactNode }) => {
  const { isMedium, isLarge, isExtraLarge } = useScreenResolution();
  const isMediumOrLarger = isMedium || isLarge || isExtraLarge;

  return (
    <div>
      <Surface
        p="24px"
        variant="primary"
        data-cy="cart-summary-card"
        className={styles['cart-summary-container']}
        radius={isMediumOrLarger ? '16px' : undefined}
      >
        {children}
      </Surface>
    </div>
  );
};

export default CartSummaryWrapper;
